import { BaseController } from './BaseController';
import { postForm } from '../Utils/helpers';

export default class MailListSubscribeController extends BaseController {
  id = 'MailListSubscribeController';

  init() {
    this.root = this.getRoot();
    this.form = this.singleChildNode('registration-form');
    this.btnSubmit = this.singleChildNode('btn-submit');
    this.imgDone = this.singleChildNode('img-done');
    this.emailField = this.singleChildNode('email-input');
    this.csrfToken = this.singleChildNode('csrf');

    this.query = '';

    this.btnSubmit.addEventListener('click', this.handleSubmit);
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const url = '/subscribe/user/';
    this.query = postForm(url, this.postResults, {'X-CSRFToken': this.csrfToken.value}, {'email': this.emailField.value});
  };

  postResults = () => {
    if (this.query.readyState === XMLHttpRequest.DONE) {
      if (this.query.status === 0 || (this.query.status >= 200 && this.query.status < 400)) {
        this.btnSubmit.classList.add('d-none');
        this.imgDone.classList.remove('d-none');
        this.emailField.value = '';
      }
    }  
  };
}
